module.exports = __webpack_public_path__ + "img/jc-cqwl.704807d2.jpg";